import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class NoAuthGuard  {
    constructor(
      private router: Router,
      private _authService: AuthService
    ) {}
  
    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): boolean {
      if (this._authService.getToken()) {
        this.router.navigate(["/dashboard"]);
        return false;
      } else {
        return true;
      }
    }
  }
  